import { graphql } from "../../gql/gql";

const getSingleSportBetsQuery = graphql(`
  query getSingleSportBetsQuery($slug: String) {
    getSupportedSports(slug: $slug) {
      featuredBetHeading {
        type
        props {
          marketId
          marketName
          marketStatus
          marketType
          inPlay
          sgmMarket
          externalMarketId
          selections {
            selectionId
            odds
            handicap
            formattedHandicap
            runnerName
            runnerStatus
            url
            sortPriority
            result {
              type
            }
          }
        }
      }
      featuredBetFooter {
        type
        props {
          marketId
          marketName
          marketStatus
          marketType
          inPlay
          sgmMarket
          externalMarketId
          selections {
            selectionId
            odds
            handicap
            formattedHandicap
            runnerName
            runnerStatus
            url
            sortPriority
            result {
              type
            }
          }
        }
      }
      featuredBetPage {
        type
        props {
          marketId
          marketName
          marketStatus
          marketType
          inPlay
          sgmMarket
          externalMarketId
          selections {
            selectionId
            odds
            handicap
            formattedHandicap
            runnerName
            runnerStatus
            url
            sortPriority
            result {
              type
            }
          }
        }
      }
    }
  }
`);

export default getSingleSportBetsQuery;
